import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Typography, WithInfoIcon } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { serviceModel } from '~/models';
import { selectors } from '~/store/state-selectors';
import { utils } from '~/utils';
import styles from './PriceDisplay.module.scss';
export const GetPriceDisplayTID = (parentTestId)=>getTestIds(parentTestId);
export default function PriceDisplay(props) {
    const { service, isActiveAgreement, priceAfterDiscount, priceBeforeDiscount, postfixPrice, error, testId = '' } = props;
    const isVendor = useStore(selectors.user.isVendor);
    const { t: serviceTexts } = useLocaleKeys('components.serviceDetails');
    const { PriceDisplayTID } = useMemo(()=>GetPriceDisplayTID(testId), [
        testId
    ]);
    const skin = (defaultSkin)=>error ? 'error' : defaultSkin;
    const includedServices = serviceModel.includedServices(service);
    const hasIncludedServices = !!includedServices && includedServices.length > 0;
    function renderBundlePriceInfo() {
        return hasIncludedServices ? /*#__PURE__*/ _jsxs(Typography, {
            skin: "invertedStandard",
            testId: PriceDisplayTID.BundlePriceInfo(),
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    skin: "invertedStandard",
                    weight: "normal",
                    children: "Included service rates:"
                }),
                "\xa0",
                /*#__PURE__*/ _jsx("ul", {
                    children: includedServices.map((includedService, index)=>/*#__PURE__*/ _jsxs("li", {
                            className: styles.infoBullet,
                            "data-testid": PriceDisplayTID.BundlePriceInfoItem(index),
                            children: [
                                includedService.name,
                                " (",
                                utils.formatDollarAmount(utils.applyDiscount(includedService.rate, service.cost.discount)),
                                ")"
                            ]
                        }, includedService.id))
                }),
                "\xa0",
                /*#__PURE__*/ _jsx(Typography, {
                    skin: "invertedStandard",
                    children: serviceTexts.hiddenRateInfo()
                })
            ]
        }) : /*#__PURE__*/ _jsx(_Fragment, {});
    }
    return /*#__PURE__*/ _jsxs(WithInfoIcon, {
        info: renderBundlePriceInfo(),
        showInfo: isVendor && hasIncludedServices && isActiveAgreement,
        infoTestId: PriceDisplayTID.BundlePriceInfoIcon(),
        className: styles.price,
        placement: "right",
        testId: testId + 'price',
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.priceAndUnit,
                "data-testid": testId + 'price-after-discount',
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "h4",
                        skin: skin('standard'),
                        children: priceAfterDiscount
                    }),
                    postfixPrice && /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        skin: skin('secondary'),
                        children: postfixPrice
                    })
                ]
            }),
            priceBeforeDiscount && /*#__PURE__*/ _jsx("div", {
                "data-testid": testId + 'price-before-discount',
                children: /*#__PURE__*/ _jsx(Typography, {
                    skin: skin('secondary'),
                    textDecoration: "line-through",
                    children: priceBeforeDiscount
                })
            })
        ]
    });
}
